import { Component, OnInit } from '@angular/core';
import { PlayerService } from '/Users/curtis/Downloads/Listen.FM_Build_myself/source_4.2.2020/fm181/src/_services/index';

import { NgForm } from '@angular/forms';

import { Options, ChangeContext, PointerType } from 'ng5-slider';


@Component({
  selector: 'app-player',
  templateUrl: './player.component.html'
})
export class PlayerComponent implements OnInit {
  player: any;
  volume: number = 10;
  expanded: boolean;
  hiddePlayer: boolean;
  minValue: number = 0;
  maxValue: number = 10;
  options: Options = {
    floor: 0,
    ceil: 10,
    vertical: true,
    showTicks: false
  }



  constructor(public playerService: PlayerService) {
    this.expanded = false;
  }

  ngOnInit() {
    this.hiddePlayer = false;
    this.init();
  }

  init() {
    this.playerService.getPlayer().subscribe((player: any) => {
      if (player) {
        this.player = player;
      }
    });
  }

  toggleAudio() {
    this.playerService.togglePlayer(true);
  }

  onUserChange(changeContext: ChangeContext): void {
    let volume = 10
    volume = changeContext.value / 10;
    this.playerService.changeVolume(volume);
  }

  toggleVolume() {
    this.expanded = !this.expanded;
  }


}
